import Reveal from "./Reveal";

export default function Hero({ whatsappNumber, content, uiStrings, elementVisibility }) {
  const HERO_BG = content?.bg_image || "https://rprxbmedkxonfbhzriwn.supabase.co/storage/v1/object/public/site/hero/hero-bg.jpg";

  const imgAlt = content?.img_alt || uiStrings?.general?.hero_img_alt || "Interior sofisticado com luz quente";
  const waMsg = content?.whatsapp_message || uiStrings?.general?.whatsapp_message || "Olá, gostaria de conhecer os serviços do Hub Profissional.";
  const scrollText = uiStrings?.general?.scroll || "Scroll";
  
  const waDigits = (whatsappNumber || "").replace(/\D/g, "");
  const waLink = `https://wa.me/${waDigits}?text=${encodeURIComponent(waMsg)}`;

  const srcset = (() => {
    if (HERO_BG.includes("unsplash")) {
      return `${HERO_BG.replace(/w=\d+/, "w=800")} 800w, ${HERO_BG.replace(/w=\d+/, "w=1200")} 1200w, ${HERO_BG.replace(/w=\d+/, "w=1600")} 1600w, ${HERO_BG.replace(/w=\d+/, "w=2400")} 2400w`;
    }
    if (HERO_BG.includes("supabase")) {
      const base = HERO_BG.split("?")[0];
      return `${base}?width=800&quality=75 800w, ${base}?width=1200&quality=80 1200w, ${base}?width=1600&quality=80 1600w, ${base}?width=2400&quality=85 2400w`;
    }
    return undefined;
  })();

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-[100dvh] min-h-[560px] md:min-h-[640px] w-full overflow-hidden grain"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          srcSet={srcset}
          sizes="100vw"
          alt={imgAlt}
          className="w-full h-full object-cover animate-kenburns"
          fetchpriority="high"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-softblack/80 via-softblack/40 to-softblack/30" />
      <div className="absolute inset-0 bg-gradient-to-r from-softblack/40 via-transparent to-transparent" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(80% 50% at 75% 30%, rgba(200,169,126,0.18), transparent 70%)",
        }}
      />

      <div className="relative h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-end pb-16 md:pb-28">
        <Reveal delay={150}>
          <p className="eyebrow !text-fendi/90" data-testid="hero-eyebrow">
            {content?.eyebrow || "Consultoria · Patrimônio · Design"}
          </p>
        </Reveal>
        <Reveal delay={300}>
          <h1
            data-testid="hero-headline"
            className="font-serif text-offwhite mt-6 max-w-4xl text-[clamp(32px,7vw,80px)] leading-[1.05] lg:leading-[0.98] tracking-tight"
          >
            {content?.headline || "Transformando visões em patrimônio e design de alto padrão."}
          </h1>
        </Reveal>
        <Reveal delay={500}>
          <p
            data-testid="hero-subheadline"
            className="text-fendi/90 mt-6 md:mt-8 max-w-xl text-sm sm:text-base md:text-lg font-light leading-relaxed"
          >
            {content?.subheadline || "Consultoria estratégica, design sofisticado e soluções inteligentes para quem busca crescimento, posicionamento e conquistas reais."}
          </p>
        </Reveal>
        {elementVisibility?.hero_cta !== false && (
          <Reveal delay={700}>
            <div className="mt-10 md:mt-12 flex flex-col sm:flex-row gap-3" data-testid="hero-actions">
              <a href="#servicos" data-testid="hero-cta-services" className="btn-light text-center">
                {content?.cta_secondary || "Conhecer Serviços"}
              </a>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-cta-whatsapp"
                className="btn-primary text-center"
              >
                {content?.cta_primary || "Falar no WhatsApp"}
              </a>
            </div>
          </Reveal>
        )}

        {elementVisibility?.hero_scroll !== false && (
          <div className="absolute bottom-10 right-10 hidden md:flex flex-col items-center gap-3 text-fendi/70">
            <span className="eyebrow !text-fendi/60 rotate-90 origin-center mt-12 mb-12">{scrollText}</span>
            <div className="w-px h-16 bg-fendi/40" />
          </div>
        )}
      </div>
    </section>
  );
}
